<template>
  <input class="submit-button" type="submit" :value="value" />
</template>

<script>
export default {
  props: {
    value: String
  }
}
</script>

<style lang="scss">
.submit-button {
  cursor: pointer;
  border: 2px solid transparent;
  background-color: white;
  padding: 8px 12px;
  font-size: 20px;
  border-radius: 6px;
  width: 80%;
  outline: none;

  &:hover {
    background-color: blue;
    color: white;
  }
}
</style>
